import React from 'react'

import { Icon, Image, Video } from 'stardust'

import { isWebView } from '~/config'
import HlsVideo from '~/ui-components/HlsVideo'

interface MediaPlayerProps {
  coverUrl?: string
  height?: string | string[]
  mimeType: string
  title?: string
  url: string
}

const MediaPlayer = ({ height, mimeType, url, coverUrl, title = '' }: MediaPlayerProps) => {
  const type = mimeType ?? ''

  if (type.includes('video')) {
    return (
      <Video
        autoPlay={false}
        maxHeight={height}
        maxWidth="100%"
        preload="metadata"
        src={url}
        controlsList={isWebView ? 'nodownload' : ''}
      />
    )
  }

  if (type.includes('vnd.apple.mpegurl')) {
    return <HlsVideo coverUrl={coverUrl} src={url} />
  }

  if (type.includes('image')) {
    return <Image alt={title} maxHeight={height} src={url} />
  }

  return <Icon name="imagePlaceholder" width={100} fill="cosmicShade2" />
}

MediaPlayer.displayName = 'MediaPlayer'

export default React.memo(MediaPlayer)
